import {
  Frame,
  ImageUploaderMenuTop,
  Pagination,
  SecureImage,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderItem,
  TableRow,
  TableWrapper,
  Text
} from '@components';
import {
  FemaleBodyChildOptionValueEnum,
  HorizontalAngleChildOptionValueEnum,
  FrameChildOptionValueEnum,
  SexualBodyPartChildOptionValueEnum,
  SexualPositionChildOptionValueEnum,
  VerticalAngleChildOptionValueEnum
} from '@constant';
import { useImageUploaderImageList } from '@hooks';
import { Button } from '@mui/material';
import { colorSet } from '@theme';
import { getEnumKeyByValue } from '@utils';

const ImageUploaderImageListPage = () => {
  const { handleImageUploadButtonClick, handleTableRowClick, tableHeader, response, page, setPage } =
    useImageUploaderImageList();

  return (
    <>
      <ImageUploaderMenuTop />

      <Frame width="100%" padding="48px 40px 96px 40px">
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '40px'
          }}
        >
          <Text variant="h2" fontWeight="bold">
            19금 이미지 리스트
          </Text>
          <Button variant="contained" color="primary" onClick={handleImageUploadButtonClick}>
            이미지 업로드
          </Button>
        </div>

        <TableWrapper width="100%">
          <Table width="100%">
            <TableHeader>
              {tableHeader.map((header, key) => (
                <TableHeaderItem key={key} width={header.width}>
                  <Text color="white" fontWeight="bold" align="center">
                    {header.label}
                  </Text>
                </TableHeaderItem>
              ))}
            </TableHeader>
            <TableBody>
              {response?.data && response?.data.length > 0
                ? response.data.map((row, key) => (
                    <TableRow
                      key={key}
                      onClick={() => {
                        handleTableRowClick(row.id, row.sequence?.id);
                      }}
                      style={{ cursor: 'pointer' }}
                      hideBorderBottom={Boolean(
                        response.data[key].sequence &&
                          response.data[key + 1] &&
                          response.data[key + 1].sequence &&
                          response.data[key].sequence?.id === response.data[key + 1].sequence?.id
                      )}
                    >
                      <TableCell width={tableHeader[0].width}>
                        <Text>{row.id}</Text>
                      </TableCell>
                      <TableCell width={tableHeader[1].width}>
                        <Text>{row.sequence?.id ?? ''}</Text>
                      </TableCell>
                      <TableCell width={tableHeader[2].width} padding="8px 12px">
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                          <div
                            style={{
                              width: 42,
                              height: 56,
                              border: `1px solid ${colorSet.gray300}`,
                              borderRadius: '3px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginRight: '12px'
                            }}
                          >
                            <SecureImage
                              imageUrl={row.s3Url ?? ''}
                              imageStyle={{ width: 34, height: 48, objectFit: 'contain' }}
                            />
                          </div>
                          <div
                            style={{
                              width: tableHeader[2].width - 78,
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'flex-start'
                            }}
                          >
                            <Text variant="body1" className="ellipsis-two-line" align="left">
                              {row.name}
                            </Text>
                          </div>
                        </div>
                      </TableCell>
                      <TableCell width={tableHeader[3].width} padding="16px 12px" justifyContent="flex-start">
                        <Text align="left">
                          {getEnumKeyByValue(SexualPositionChildOptionValueEnum, row.imageOptionValue.체위)}
                        </Text>
                      </TableCell>
                      <TableCell width={tableHeader[4].width} padding="16px 12px" justifyContent="flex-start">
                        <Text align="left">
                          {getEnumKeyByValue(FemaleBodyChildOptionValueEnum, row.imageOptionValue.여체)}
                        </Text>
                      </TableCell>
                      <TableCell width={tableHeader[5].width} padding="16px 12px" justifyContent="flex-start">
                        <Text align="left">
                          {getEnumKeyByValue(SexualBodyPartChildOptionValueEnum, row.imageOptionValue.신체부위)}
                        </Text>
                      </TableCell>
                      <TableCell width={tableHeader[6].width} padding="16px 12px" justifyContent="flex-start">
                        <Text align="left" style={{ whiteSpace: 'pre-line' }}>
                          {row?.imageOptionValue['남성 인원수'] != null && row?.imageOptionValue['여성 인원수'] != null
                            ? `남자 ${row?.imageOptionValue['남성 인원수']}
                            여자 ${row?.imageOptionValue['여성 인원수']}`
                            : ''}
                        </Text>
                      </TableCell>
                      <TableCell width={tableHeader[7].width} padding="16px 12px" justifyContent="flex-start">
                        <Text align="left">
                          {getEnumKeyByValue(FrameChildOptionValueEnum, row.imageOptionValue['샷 구분'])}
                        </Text>
                      </TableCell>
                      <TableCell width={tableHeader[8].width} padding="16px 12px" justifyContent="flex-start">
                        <Text align="left">
                          {getEnumKeyByValue(HorizontalAngleChildOptionValueEnum, row.imageOptionValue['가로앵글'])}
                        </Text>
                      </TableCell>
                      <TableCell width={tableHeader[9].width} padding="16px 12px" justifyContent="flex-start">
                        <Text align="left">
                          {getEnumKeyByValue(VerticalAngleChildOptionValueEnum, row.imageOptionValue['세로앵글'])}
                        </Text>
                      </TableCell>
                      <TableCell width={tableHeader[10].width} padding="16px 12px" justifyContent="flex-start">
                        <Text
                          align="left"
                          style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            width: '100%' // 또는 원하는 특정 너비 값
                          }}
                        >
                          {row.tags
                            ? row.tags.map((item, index) => `${item.name}${index === row.tags.length - 1 ? '' : ', '}`)
                            : ''}
                        </Text>
                      </TableCell>
                    </TableRow>
                  ))
                : []}
            </TableBody>
          </Table>
        </TableWrapper>

        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-end' }}>
          <div style={{ display: 'flex', flexDirection: 'row', gap: 8, alignItems: 'center' }}>
            <Text variant="body1">Total</Text>
            <Text variant="subtitle" fontWeight="bold">
              {response?.meta?.itemCount ?? 0}
            </Text>
          </div>
          <Pagination page={page} pageCount={response?.meta?.pageCount ?? 0} onChange={setPage} />
        </div>
      </Frame>
    </>
  );
};

export default ImageUploaderImageListPage;
